import dicomImageLoader from '@cornerstonejs/dicom-image-loader';

import FileLoader from './fileLoader';
import PDFFileLoader from './pdfFileLoader';
import TXTFileLoader from './textFileLoader';
import DICOMFileLoader from './dicomFileLoader';

let _nonDicomCounter = 0;

class FileLoaderService extends FileLoader {
  fileType;
  loader;
  constructor(file) {
    super();
    const fileType = file && file.type;
    this.loader = this.getLoader(fileType);
    this.fileType = this.loader.fileType;
  }

  addFile(file) {
    if (this.fileType === 'application/pdf' || this.fileType === 'text/plain') {
      return `non-dicom://${file.name || 'file'}_${++_nonDicomCounter}`;
    }
    return dicomImageLoader.wadouri.fileManager.add(file);
  }

  loadFile(file, imageId) {
    return this.loader.loadFile(file, imageId);
  }

  getDataset(image, imageId) {
    return this.loader.getDataset(image, imageId);
  }

  getLoader(fileType) {
    if (fileType === 'application/pdf') {
      return PDFFileLoader;
    } else if (fileType === 'text/plain') {
      return TXTFileLoader;
    } else {
      return DICOMFileLoader;
    }
  }
}

export default FileLoaderService;
